var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('svg', {
        attrs: {
            "height": _vm.size,
            "viewBox": "0 0 90 40"
        }
    }, [
        _c('g', {
            attrs: {
                "stroke": "none",
                "stroke-width": "1",
                "fill": "none",
                "fill-rule": "evenodd"
            }
        }, [
            _c('circle', {
                attrs: {
                    "fill": "#4D88FF",
                    "cx": "20",
                    "cy": "16",
                    "r": "8"
                }
            }, [
                _c('animate', {
                    attrs: {
                        "attributeName": "cy",
                        "from": "16",
                        "to": "16",
                        "dur": "1.5s",
                        "begin": "0s",
                        "repeatCount": "indefinite",
                        "values": "16; 8; 26; 16; 16",
                        "keyTimes": "0; 0.2; 0.4; 0.6; 1"
                    }
                })
            ]),
            _c('circle', {
                attrs: {
                    "fill": "#17E6CE",
                    "cx": "46",
                    "cy": "16",
                    "r": "8"
                }
            }, [
                _c('animate', {
                    attrs: {
                        "attributeName": "cy",
                        "from": "16",
                        "to": "16",
                        "dur": "1.5s",
                        "begin": "0.1s",
                        "repeatCount": "indefinite",
                        "values": "16; 8; 26; 16; 16",
                        "keyTimes": "0; 0.2; 0.4; 0.6; 1"
                    }
                })
            ]),
            _c('circle', {
                attrs: {
                    "fill": "#FF884D",
                    "cx": "72",
                    "cy": "16",
                    "r": "8"
                }
            }, [
                _c('animate', {
                    attrs: {
                        "attributeName": "cy",
                        "from": "16",
                        "to": "16",
                        "dur": "1.5s",
                        "begin": "0.2s",
                        "repeatCount": "indefinite",
                        "values": "16; 8; 26; 16; 16",
                        "keyTimes": "0; 0.2; 0.4; 0.6; 1"
                    }
                })
            ])
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
